<!-- 预览弹窗 -->
<template>
  <lzd-modal
    ref="eleModalRef"
    class="word-dialog"
    :width="width"
    :position="{ top: 0 }"
    :model-value="modelValue"
    :title="title"
    :close-on-click-modal="false"
    :responsive="true"
    @update:modelValue="updateModelValue"
  >
    <!-- :style="{ 'pointer-events': !isUpdate ? 'none' : 'auto' }" -->
    <div v-loading="loading">
      <!-- 封面 -->
      <div
        class="t-a-c"
        :style="titleStyle"
        style="text-underline-offset: 10px"
        >{{ form.title }}</div
      >
      <div class="h-10_5pt"></div>

      <div class="t-a-c">
        <span style="margin-right: 20px">
          发布时间：
          {{
            form.publisherAt
              ? LzdUtil.dateFormat(form.publisherAt, 'YYYY-MM-DD')
              : ''
          }}
        </span>
        <span>浏览量：{{ form.browses }}</span>
      </div>
      <div class="h-10_5pt"></div>
      <div style="pointer-events: none">
        <lzd-editor
          v-model="form.content"
          min-height="200pt"
          :type="'richtext'"
          format="json"
        />
      </div>
      <div class="h-10_5pt"></div>
      <div class="h-10_5pt"></div>
      <!-- 时间 -->
      <div class="h-10_5pt"></div>
      <div class="h-10_5pt"></div>
      <div style="margin-top: 30px">
        <div v-for="row in fileTableList" :key="row.fileName" class="file-item">
          <img
            style="margin-left: 18px"
            src="/ele-file-list/ic_file_folder.png"
            alt="文件图标"
            class="file-icon"
          />
          <el-link type="default" underline @click="downloadFileByUrl(row)">
            {{ row.fileName }} ({{ formatSize(row) }})
          </el-link>
          <span style="color: grey">已下载 {{ row.downloads }} 次</span>
        </div>
      </div>
    </div>
  </lzd-modal>
</template>

<script lang="ts" setup>
  import '@/styles/font/style.scss';
  import { ref, watch } from 'vue';
  import { useFormData } from '@/utils/use-form-data';
  import type { TenantNotice } from '@/api/bsl/tenant/notice/list/model';
  import type { TenantResource } from '@/api/bsl/tenant/resource/list/model';
  import fileUtil from '@/utils/file-util';
  import LzdUtil, { tipsError } from '@/utils/lzd-util';
  import { updateTenantResourceDownloads } from '@/api/bsl/tenant/resource/list';

  const props = defineProps<{
    modelValue: boolean;
    title: string;
    data?: TenantNotice;
  }>();

  const emit = defineEmits<{
    (e: 'done'): void;
    (e: 'update:modelValue', modelValue: boolean): void;
  }>();

  /** 表单数据 */
  const [form, resetFields, assignFields] = useFormData<Partial<TenantNotice>>({
    seq: void 0,
    id: '',
    title: '',
    titleStyle: void 0,
    titleIcon: void 0,
    content: '',
    college: '',
    department: '',
    teaching: '',
    major: '',
    published: 0,
    publisherId: '',
    publisherName: '',
    publisherAt: void 0,
    hideRoles: '',
    showRoles: '',
    home: 0,
    authorized: 1,
    sortNumber: 0,
    browses: void 0,
    attachments: []
  });

  const loading = ref(false);

  const titleStyle = ref({});
  const showModelValue = ref(false);

  /**
   * 将数据库存储的 JSON 样式转换为 CSS 对象
   * @param styleStr JSON 字符串或对象
   */
  const formatTitleStyle = (styleStr: any) => {
    if (!styleStr) return {};
    try {
      const obj =
        typeof styleStr === 'string' ? JSON.parse(styleStr) : styleStr;

      return {
        fontFamily: obj.font || 'inherit',
        fontSize: obj.size
          ? isNaN(Number(obj.size))
            ? obj.size
            : `${obj.size}px`
          : 'inherit',
        color: obj.color || 'inherit',
        fontWeight: obj.bold ? 'bold' : 'normal',
        textDecoration: obj.underline ? 'underline' : 'none'
      };
    } catch (e) {
      console.error('解析 titleStyle 失败:', e);
      return {};
    }
  };

  watch(
    () => props.modelValue,
    (modelValue) => {
      if (modelValue && props.data) {
        const newData = props.data;
        if (!newData.seq) {
          tipsError('SEQ不能为空');
          return;
        }
        assignFields(newData);

        titleStyle.value = formatTitleStyle(newData.titleStyle);

        fileTableList.value = newData.attachments ?? [];
      } else {
        resetFields();
      }
    }
  );

  /** 文件下载 */
  const downloadFileByUrl = (row: TenantResource) => {
    fileUtil.downloadFile(row.fileUrl, row.fileName);
    updateTenantResourceDownloads(row).catch((error) => {
      tipsError(error.message);
    });
  };

  /** 更新modelValue */
  const updateModelValue = (value: boolean) => {
    emit('update:modelValue', value);
    showModelValue.value = false;
  };

  const formatSize = (row: TenantResource) => {
    return (row.fileSize / (1024 * 1024)).toFixed(2) + ' MB';
  };

  // 文件列表
  const fileTableList = ref<TenantResource[]>([]);

  /** 计算浏览器宽 */
  const getWidth = (): number => globalThis.innerWidth - 32;
  const width = ref(getWidth());
  if (width.value > globalThis.devicePixelRatio * 96 * (21 / 2.54)) {
    width.value = globalThis.devicePixelRatio * 96 * (21 / 2.54);
  }
</script>
<style lang="scss" scoped>
  .file-item {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    background: #f8f8f8;
    border-radius: 16px;
    height: 30px;
    max-width: 100%;
    position: relative;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    gap: 10px;
  }

  .file-icon {
    width: 20px;
    height: 20px;
    margin-right: 8px;
  }
  .h-10_5pt {
    margin-top: 10.5px;
  }
</style>
